import { TFunction } from "i18next";

import { DayOfWeek, MonthlyOrdinal } from "@/api";
import { IOptionItem } from "@/common/components/fields/formik/formik-autocomplete/FormikAutocomplete.types";

const WEEKDAYS: DayOfWeek[] = [
  DayOfWeek.Monday,
  DayOfWeek.Tuesday,
  DayOfWeek.Wednesday,
  DayOfWeek.Thursday,
  DayOfWeek.Friday,
];

const ORDINALS: MonthlyOrdinal[] = [
  MonthlyOrdinal.First,
  MonthlyOrdinal.Second,
  MonthlyOrdinal.Third,
  MonthlyOrdinal.Last,
];

export function weekdayOptions(t: TFunction): IOptionItem[] {
  const labels = weekdayFullLabels(t);
  return WEEKDAYS.map((weekday) => ({ id: weekday, label: labels[weekday] ?? "" }));
}

export function ordinalOptions(t: TFunction): IOptionItem[] {
  const labels = ordinalFullLabels(t);
  return ORDINALS.map((ordinal) => ({ id: ordinal, label: labels[ordinal] ?? "" }));
}

export function weekdayFullLabels(t: TFunction): Record<string, string> {
  return {
    [DayOfWeek.Monday]: t("settings.courts.gerichtstag.weekdays.Monday"),
    [DayOfWeek.Tuesday]: t("settings.courts.gerichtstag.weekdays.Tuesday"),
    [DayOfWeek.Wednesday]: t("settings.courts.gerichtstag.weekdays.Wednesday"),
    [DayOfWeek.Thursday]: t("settings.courts.gerichtstag.weekdays.Thursday"),
    [DayOfWeek.Friday]: t("settings.courts.gerichtstag.weekdays.Friday"),
  };
}

export function weekdayShortLabels(t: TFunction): Record<string, string> {
  return {
    [DayOfWeek.Monday]: t("settings.courts.chip.weekdaysShort.Monday"),
    [DayOfWeek.Tuesday]: t("settings.courts.chip.weekdaysShort.Tuesday"),
    [DayOfWeek.Wednesday]: t("settings.courts.chip.weekdaysShort.Wednesday"),
    [DayOfWeek.Thursday]: t("settings.courts.chip.weekdaysShort.Thursday"),
    [DayOfWeek.Friday]: t("settings.courts.chip.weekdaysShort.Friday"),
  };
}

export function ordinalFullLabels(t: TFunction): Record<string, string> {
  return {
    [MonthlyOrdinal.First]: t("settings.courts.gerichtstag.ordinals.First"),
    [MonthlyOrdinal.Second]: t("settings.courts.gerichtstag.ordinals.Second"),
    [MonthlyOrdinal.Third]: t("settings.courts.gerichtstag.ordinals.Third"),
    [MonthlyOrdinal.Last]: t("settings.courts.gerichtstag.ordinals.Last"),
  };
}

export function ordinalShortLabels(t: TFunction): Record<string, string> {
  return {
    [MonthlyOrdinal.First]: t("settings.courts.chip.ordinalsShort.First"),
    [MonthlyOrdinal.Second]: t("settings.courts.chip.ordinalsShort.Second"),
    [MonthlyOrdinal.Third]: t("settings.courts.chip.ordinalsShort.Third"),
    [MonthlyOrdinal.Last]: t("settings.courts.chip.ordinalsShort.Last"),
  };
}
